import { render, staticRenderFns } from "./dashboard-view-details-small.vue?vue&type=template&id=b4858a80"
import script from "./dashboard-view-details-small.vue?vue&type=script&lang=js"
export * from "./dashboard-view-details-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports